"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatOrdinals = exports.default = exports.RoundToDecimal = exports.HashCode = exports.GetRandomNumberBelow = exports.GetRandomBetweenInclusive = exports.GetRandomBetweenExclusive = exports.FormatNumberToMinDigits = exports.FormatDigitalTime = void 0;
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/web.dom-collections.iterator.js");
/**
 * Returns a random number between zero and the maximum provided.
 *
 * @param {number} max - The maximum number for the range
 * @returns {number} a random number smaller than or equal to the maximum
 */
const GetRandomNumberBelow = max => {
  return Math.floor(Math.random() * max);
};

/**
 * Returns a random number between a startNum and endNum where the possible result could include the bounds of the range.
 *
 * @param {number} startNum - The minimum number for the range
 * @param {number} endNum - The maximum number for the range
 * @returns {number} a random number within and including the bounds of the range
 */
exports.GetRandomNumberBelow = GetRandomNumberBelow;
const GetRandomBetweenInclusive = (startNum, endNum) => {
  const rangeSize = endNum - startNum + 1;
  return Math.floor(Math.random() * rangeSize) + startNum;
};

/**
 * Returns a random number between a startNum and endNum where the possible result cannot include the bounds of the range.
 *
 * @param {number} startNum - The maximum number for the range
 * @param {number} endNum - The maximum number for the range
 * @returns {number} a random number within but not including the bounds of the range
 */
exports.GetRandomBetweenInclusive = GetRandomBetweenInclusive;
const GetRandomBetweenExclusive = (startNum, endNum) => {
  const rangeSize = endNum - startNum - 1;
  if (rangeSize === 0) {
    return startNum + 0.5;
  }
  if (rangeSize < 0) {
    return startNum;
  }
  return Math.floor(Math.random() * rangeSize) + startNum + 1;
};

/**
 * Takes a string and hashes it. This is useful for faking a UID.
 *
 * @param {string} pString - A string of text.
 * @returns {number} a hash of the string.
 */
exports.GetRandomBetweenExclusive = GetRandomBetweenExclusive;
const HashCode = pString => {
  let hash = 0;
  let i;
  let chr;
  for (i = 0; i < pString.length; i += 1) {
    chr = pString.charCodeAt(i);
    // The bitwise operations used below are required to achieve the hashed formatting.
    // eslint-disable-next-line no-bitwise
    hash = (hash << 5) - hash + chr;
    // eslint-disable-next-line no-bitwise
    hash |= 0; // Convert to 32bit integer
  }

  return hash;
};

/**
 * Rounds a number to the specified number of decimal points.
 *
 * @param {number} num - The number to round
 * @param {number} numDecimalPoints - The number of decimal places to round it to.
 * @returns {number} A rounded number.
 */
exports.HashCode = HashCode;
const RoundToDecimal = (num, numDecimalPoints) => {
  if (numDecimalPoints === 0) {
    return Math.trunc(num);
  }
  const roundingFactor = 10 ** numDecimalPoints;
  return Math.round(num * roundingFactor) / roundingFactor;
};

/**
 * Converts a number to a string with the specified number of digits.
 *
 * @param {number} num - The number to round
 * @param {number} numDigits - The number of digits it needs to be padded to in total.
 * @param {string} padDirection - Whether to pad it to the left eg 005 or right eg 500. Default is left.
 * Note: If the number is longer than the required number of digits it will truncate on this side instead.
 * @param {string} padCharacter - The character to use for the padding. Default is '0'.
 * @returns {string} The number with padding applied to the left or right.
 */
exports.RoundToDecimal = RoundToDecimal;
const FormatNumberToMinDigits = exports.FormatNumberToMinDigits = function FormatNumberToMinDigits(num, numDigits) {
  let padDirection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  let padCharacter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '0';
  const numberAsString = num.toString();
  const numberAsStringLength = numberAsString.length;
  const requiredPaddingLength = numDigits - numberAsStringLength;
  if (numberAsStringLength === numDigits) {
    return numberAsString;
  }
  if (numberAsStringLength > numDigits) {
    return padDirection === 'right' ? numberAsString.substring(0, numDigits) : numberAsString.substring(numberAsStringLength - numDigits);
  }
  let padding = new Array(requiredPaddingLength).fill(padCharacter).join('');
  if (padding.length > requiredPaddingLength) {
    padding = padding.substring(0, requiredPaddingLength);
  }
  return padDirection && padDirection === 'right' ? "".concat(numberAsString).concat(padding) : "".concat(padding).concat(numberAsString);
};
const FormatDigitalTime = milliseconds => {
  const hours = Math.floor(milliseconds / 1000 / 60 / 60);
  const minutes = Math.floor((milliseconds - hours * 1000 * 60 * 60) / 1000 / 60);
  const seconds = Math.floor((milliseconds - hours * 1000 * 60 * 60 - minutes * 1000 * 60) / 1000);
  const formattedHours = FormatNumberToMinDigits(hours, 2);
  const formattedMinutes = FormatNumberToMinDigits(minutes, 2);
  const formattedSeconds = FormatNumberToMinDigits(seconds, 2);
  return "".concat(formattedHours, ":").concat(formattedMinutes, ":").concat(formattedSeconds);
};
exports.FormatDigitalTime = FormatDigitalTime;
const formatOrdinals = number => {
  const enOrdinalRules = new Intl.PluralRules('en-US', {
    type: 'ordinal'
  });
  const suffixes = new Map([['one', 'st'], ['two', 'nd'], ['few', 'rd'], ['other', 'th']]);
  const rule = enOrdinalRules.select(number);
  const suffix = suffixes.get(rule);
  return "".concat(number).concat(suffix);
};
exports.formatOrdinals = formatOrdinals;
var _default = exports.default = {
  FormatNumberToMinDigits,
  FormatDigitalTime,
  GetRandomBetweenInclusive,
  GetRandomNumberBelow,
  GetRandomBetweenExclusive,
  formatOrdinals,
  HashCode
};